import { defineMessages } from 'react-intl';

export default defineMessages({
    tryAgainLater: {
        id: 'adac.try-again-page.Try again later',
        defaultMessage: 'Try again later'
    },
    unableToProcess: {
        id: 'adac.try-again-page.We are unable to process you request online right now',
        defaultMessage: 'We are currently unable to process your request online.'
    },
    pleaseCall: {
        id: 'adac.try-again-page.Please try again later or contact our ADAC Ambulance-Service using the below phone number',
        defaultMessage: 'Please try again later or contact our ADAC Ambulanze-Service using the below phone number: {phoneNumber}'
    }
});
